import React from "react";
import clsx from "clsx";

type LogoProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const Logo = ({ className, ...props }: LogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 65 65"
    fill="currentColor"
    className={clsx(className)}
    {...props}
  >
    <title>{"AI Expedite Logo"}</title>
    <path d="M25.8 41.1c1.3-4.4 6.1-18.8-8.1-20.9C3.3 18.2.6 32.9.6 32.9s-3.4 9.2 6.2 20.4c11.5 13.5 26.4 11.4 26.4 11.4-13.3-4.3-8.8-19.1-7.4-23.6z" />
    <path d="M60.7 18.6c2.6 13.7-12.5 16.8-17.1 17.8-4.5 1-19.5 3.7-14.4 17.2 5.2 13.6 19.4 8.8 19.4 8.8s9.7-1.4 14.8-15.2c6.2-16.6-2.7-28.6-2.7-28.6z" />
    <path d="M29.7 22.3c2.4 3.9 9.9 17.1 20.9 7.9 11.2-9.4 1.9-21.3 1.9-21.3S47.9.3 33.2 0c-17.7-.3-26 12.1-26 12.1 12-7 20 6.2 22.5 10.2z" />
  </svg>
);

export default Logo;
